const getMoodStressLineData = (moodData, stressData) => {
    return {
        labels: Object.keys(moodData),
        datasets: [
            {
                label: 'Mood',
                data: Object.values(moodData),
                borderColor: 'rgb(53, 162, 235)',
                backgroundColor: 'rgba(53, 162, 235, 0.5)',
            },
            {
                label: 'Stress',
                data: Object.values(stressData),
                borderColor: 'rgb(255, 99, 132)',
                backgroundColor: 'rgba(255, 99, 132, 0.5)',
            },
        ],
    };
};

const getSatisfactionTirednessLineData = (moodData, questionData) => {
    return {
        labels: Object.keys(moodData),
        datasets: [
            {
                label: 'Satisfaction',
                data: Object.values(questionData.satisfaction),
                borderColor: 'rgb(255, 99, 132)',
                backgroundColor: 'rgba(255, 99, 132, 0.5)',
            },
            {
                label: 'Tiredness',
                data: Object.values(questionData.tiredness),
                borderColor: 'rgb(75, 192, 192)',
                backgroundColor: 'rgba(75, 192, 192, 0.5)',
            },
        ],
    };
};

const getMoodStressBarData = (moodScore, stressScore) => {
    return {
        labels: ['Mood', 'Stress'],
        datasets: [{
            label: 'Score',
            data: [moodScore, stressScore],
            backgroundColor: [
                'rgba(53, 162, 235, 0.5)',
                'rgba(255, 99, 132, 0.5)',
            ],
            borderColor: [
                'rgb(53, 162, 235)',
                'rgb(255, 99, 132)',
            ],
            borderWidth: 1,
            barThickness: 60,
        }],
    };
};

const getSatisfactionTirednessBarData = (satisfaction, tiredness) => {
    return {
        labels: ['Satisfaction', 'Tiredness'],
        datasets: [{
            label: 'Score',
            data: [satisfaction, tiredness],
            backgroundColor: [
                'rgba(255, 99, 132, 0.5)',
                'rgba(75, 192, 192, 0.5)',
            ],
            borderColor: [
                'rgb(255, 99, 132)',
                'rgb(75, 192, 192)',
            ],
            borderWidth: 1,
            barThickness: 60,
        }],
    };
};

const standardNormalData = {
    labels: ['-3', '-2', '-1', '0', '1', '2', '3'],
    datasets: [
        {
            data: [0.0013, 0.0228, 0.1587, 0.3413, 0.1587, 0.0228, 0.0013],
            borderColor: 'rgb(255, 99, 132)',
            backgroundColor: 'rgba(255, 99, 132, 0.5)',
            lineTension: 0.3,
        },
    ],
};

export { getMoodStressLineData, getSatisfactionTirednessLineData, getMoodStressBarData, getSatisfactionTirednessBarData, standardNormalData };
